/** About the store. Only facts about how the store works: no invented history. */
import type { InfoDoc } from "../types";

export const about: InfoDoc = {
  es: {
    title: "Nosotros",
    intro: "pokefans.fun es una tienda online de Pokémon TCG en Argentina, hecha por fans para fans.",
    sections: [
      {
        title: "Qué hacemos",
        paragraphs: [
          "Vendemos cartas sueltas y productos sellados originales de Pokémon TCG: sobres, cajas, Elite Trainer Box, colecciones, mazos y accesorios.",
          "Cada carta se revisa y se publica con su estado, terminación e idioma, para que sepas exactamente qué vas a recibir.",
        ],
      },
      {
        title: "Nuestra empresa en Estados Unidos",
        paragraphs: [
          "En Estados Unidos, pokefans.fun opera a través de Gomesin IT LLC, una sociedad de responsabilidad limitada registrada en el estado de Nuevo México.",
          "Gomesin IT LLC es la empresa que compra el producto sellado a distribuidores y la que lleva adelante nuestras ventas en el mercado estadounidense. Las ventas a clientes en Argentina las realiza nuestra operación local.",
          "Para consultas comerciales, mayoristas o de distribución, escribinos a {email}.",
        ],
      },
      {
        title: "Precios claros",
        paragraphs: [
          "Los precios siguen al mercado internacional y los de las cartas se revisan todos los días. Los publicamos en dólares y te mostramos el equivalente en pesos, así comparás sin sorpresas.",
        ],
      },
      {
        title: "Herramientas para coleccionistas",
        paragraphs: [
          "Con [[/identificar|Identificar carta]] le sacás una foto a una carta y te decimos cuál es. En cada producto sellado te contamos qué trae y qué cartas pueden salir.",
        ],
      },
      {
        title: "Compra segura",
        paragraphs: [
          "Pagás con Mercado Pago, tarjeta o PayPal; nunca vemos los datos de tu tarjeta. Tenés 10 días para arrepentirte de la compra y te respondemos rápido si algo no sale bien.",
          "¿Querés hablar con nosotros? Pasá por [[/contacto|contacto]].",
        ],
      },
    ],
  },
  en: {
    title: "About us",
    intro: "pokefans.fun is an online Pokémon TCG store in Argentina, made by fans for fans.",
    sections: [
      {
        title: "What we do",
        paragraphs: [
          "We sell genuine Pokémon TCG singles and sealed products: booster packs, boxes, Elite Trainer Boxes, collections, decks and accessories.",
          "Every card is checked and listed with its condition, finish and language, so you know exactly what you'll get.",
        ],
      },
      {
        title: "Our US company",
        paragraphs: [
          "In the United States, pokefans.fun operates through Gomesin IT LLC, a limited liability company registered in the State of New Mexico.",
          "Gomesin IT LLC is the company that purchases our sealed product from distributors and runs our sales in the US market. Sales to customers in Argentina are handled by our local operation.",
          "For business, wholesale or distribution inquiries, write to us at {email}.",
        ],
      },
      {
        title: "Clear prices",
        paragraphs: ["Prices follow the international market, and card prices are checked every day. We list them in US dollars and show the peso equivalent, so you can compare with no surprises."],
      },
      {
        title: "Tools for collectors",
        paragraphs: ["With [[/identificar|Identify a card]] you take a photo of a card and we tell you which one it is. For every sealed product we list what's inside and which cards can be pulled."],
      },
      {
        title: "Safe shopping",
        paragraphs: [
          "Pay with Mercado Pago, card or PayPal; we never see your card details. You have 10 days to change your mind, and we answer quickly if something goes wrong.",
          "Want to talk to us? Head to [[/contacto|contact]].",
        ],
      },
    ],
  },
};
